import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import Vuetify, { VLayout } from 'vuetify/lib'

/* import Vuetify, {
    VCard,
    VRating,
    VToolbar,
    VApp,
    VAppBar,
    VProgressLinear,
    VImg,
    VIcon,
    VSpacer,
    VListItem,
    VListItemTitle,
    VListItemAction,
    VSubheader,
    VLayout,
    Ripple
} from 'vuetify/lib' */

// import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
    components: {
        /*  VCard,
         VRating,
         VToolbar,
         VApp,
         VAppBar,
         VProgressLinear,
         VImg,
         VIcon,
         VSpacer,
         VListItem,
         VListItemTitle,
         VListItemAction,
         VSubheader,
         VLayout,
         Ripple */
    },
    /* directives: {
        Ripple,
    }, */
    theme: {
        themes: {
            light: {
                primary: "#5761ff", // #E53935
                secondary: "#2B2B70", // #FFCDD2
                accent: "#FF5252", // #3F51B5
                light: "#e9ebf7",
                error: '#FF5252',
                info: '#2196F3',
                success: '#66bb6a',
                warning: '#FFC107',
            },
        },
    },
    icons: {
        iconfont: 'mdiSvg',
    }
});
